import { render, staticRenderFns } from "./RenewableEnergy.vue?vue&type=template&id=289c3cb8&scoped=true&"
import script from "./RenewableEnergy.vue?vue&type=script&lang=js&"
export * from "./RenewableEnergy.vue?vue&type=script&lang=js&"
import style0 from "./RenewableEnergy.vue?vue&type=style&index=0&id=289c3cb8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289c3cb8",
  null
  
)

export default component.exports